import {
  DigitalMarketingCoverImage,
  DigitalMarketingImg,
  DigitalStrategyImg,
  MediaBuyingImg,
  OnlinePrImg,
  SocialCampaignImg,
  SEOImg,
  AffiliateImg,
  InfluenceImg,
  PPCImg,
  ContentMarketingImg,
  SocialManagementImg,
  CreativeMediaImg,
  TvcMakingImg,
  DigitalCommercialsImg,
  WebCommercialsImg,
  ExplanatoryVideosImg,
  CompanyProfileImg,
} from "../../../assets/data/Imagedata";

import {
  faBullhorn,
  faLightbulb,
  faSearchDollar,
  faUsers,
  faHashtag,
  faSearch,
  faHandHoldingUsd,
  faUserFriends,
  faMousePointer,
  faFileLines,
  faShareNodes,
  faPalette,
  faFilm,
  faVideo,
  faGlobe,
  faFileSignature,
  faIdCard,
  faCommentAlt,
  faBuilding,
  faCamera,
  faSitemap,
  faTv,
  faStar,
  faCheckCircle,
  faRocket,
  faChartLine,
  faAward,
} from "../../../assets/data/icon_data";

// Category Overview
export const DigitalMarketingCompany = {
  SeoName: { seotitle:"digital-marketing" },
  coverimage: DigitalMarketingCoverImage,
  title:"Digital Media Marketing in Visakhapatnam",
  subtitle:"ROI-driven digital marketing solutions for businesses in Vizag.",
};

// 1. MAIN DIGITAL MARKETING PAGE
export const DigitalMarketingPageData = {
  SeoName: { seotitle:"digital-marketing" },
  coverimage: DigitalMarketingCoverImage,
  title:"Digital Marketing Agency in Vizag",
  categoryLabel:"Full Service Agency",
  hero: {
    title:"Grow Your Business with the Best Digital Marketing Agency in Vizag",
    subtitle:"Leor Media provides result-driven digital marketing services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    highlights: ["Get Free Consultation","Request Proposal","Call Now"],
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best digital marketing services in Vizag?",
    text:"Leor Media is a trusted digital marketing company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  servicesTitle:"Our Services",
  services: [
    { title:"SEO", description:"Search Engine Optimization for organic growth.", icon: faSearch },
    { title:"Social Media", description:"Marketing and management for brand engagement.", icon: faUsers },
    { title:"Paid Ads", description:"Google and Meta ads for instant results.", icon: faSearchDollar },
    { title:"Content Marketing", description:"Strategic content creation and distribution.", icon: faFileLines },
  ],
  whyChooseTitle:"Why Businesses in Vizag Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic digital marketing solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Customized Solutions", description:"Tailored strategies based on industry trends and audience behavior.", icon: faRocket },
    { title:"Performance Driven", description:"ROI focused marketing that delivers real business impact.", icon: faChartLine },
    { title:"Expert Team", description:"A decade of experience in digital promotions and branding.", icon: faAward },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
    { value:"ROI", label:"Focused Strategies" },
  ],
  faqs: [
    { question:"Which is the best digital marketing company in Vizag?", answer:"Leor Media provides professional digital marketing services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does digital marketing cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized digital marketing solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can digital marketing help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 2. DIGITAL STRATEGY CONSULTING
export const DigitalStrategyConsultingPageData = {
  SeoName: { seotitle:"digital-strategy-consulting" },
  coverimage: DigitalMarketingCoverImage,
  title:"Digital Strategy Consulting in Vizag",
  categoryLabel:"Consulting Services",
  hero: {
    title:"Grow Your Business with Professional Digital Strategy Consulting Services in Vizag",
    subtitle:"Leor Media provides result-driven digital strategy consulting services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best digital strategy consulting services in Vizag?",
    text:"Leor Media is a trusted digital strategy consulting company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic digital strategy consulting solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Strategic Growth", description:"Customized marketing solutions based on industry trends.", icon: faRocket },
    { title:"Result Oriented", description:"Performance marketing strategies for measurable results.", icon: faChartLine },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best digital strategy consulting company in Vizag?", answer:"Leor Media provides professional digital strategy consulting services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does digital strategy consulting cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized digital strategy consulting solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can digital strategy consulting help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 3. DIGITAL MEDIA BUYING
export const DigitalMediaBuyingPageData = {
  SeoName: { seotitle:"digital-media-buying" },
  coverimage: DigitalMarketingCoverImage,
  title:"Digital Media Buying in Vizag",
  categoryLabel:"Media Services",
  hero: {
    title:"Grow Your Business with Professional Digital Media Buying Services in Vizag",
    subtitle:"Leor Media provides result-driven digital media buying services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best digital media buying services in Vizag?",
    text:"Leor Media is a trusted digital media buying company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic digital media buying solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Targeted Reach", description:"Customized marketing solutions based on audience behavior.", icon: faRocket },
    { title:"Performance Driven", description:"Delivering measurable business growth through strategic buying.", icon: faChartLine },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best digital media buying company in Vizag?", answer:"Leor Media provides professional digital media buying services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does digital media buying cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized digital media buying solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can digital media buying help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 4. ONLINE PR
export const OnlinePrPageData = {
  SeoName: { seotitle:"online-pr" },
  coverimage: DigitalMarketingCoverImage,
  title:"Online PR Services in Vizag",
  categoryLabel:"Public Relations",
  hero: {
    title:"Grow Your Business with Professional Online PR Services in Vizag",
    subtitle:"Leor Media provides result-driven online PR services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best online PR services in Vizag?",
    text:"Leor Media is a trusted online PR company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic online PR solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Brand Reputation", description:"Helping businesses across Andhra Pradesh build a powerful digital presence.", icon: faAward },
    { title:"Quality Leads", description:"Improving customer engagement and growing faster online.", icon: faChartLine },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best online PR company in Vizag?", answer:"Leor Media provides professional online PR services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does online PR cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized online PR solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can online PR help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 5. SOCIAL MEDIA & DIGITAL CAMPAIGN
export const SocialMediaDigitalCampaignPageData = {
  SeoName: { seotitle:"social-media-digital-campaign" },
  coverimage: DigitalMarketingCoverImage,
  title:"Social Media & Digital Campaign in Vizag",
  categoryLabel:"Campaign Services",
  hero: {
    title:"Grow Your Business with Professional Social Media & Digital Campaign Services in Vizag",
    subtitle:"Leor Media provides result-driven social media & digital campaign services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best social media & digital campaign services in Vizag?",
    text:"Leor Media is a trusted social media & digital campaign company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic social media & digital campaign solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Viral Strategy", description:"Creative solutions based on target audience behavior.", icon: faRocket },
    { title:"Growth Focused", description:"Combining technology and marketing for business growth.", icon: faChartLine },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best social media & digital campaign company in Vizag?", answer:"Leor Media provides professional social media & digital campaign services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does social media & digital campaign cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized social media & digital campaign solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can social media & digital campaign help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 6. SEARCH ENGINE OPTIMIZATION
export const SearchEngineOptimizationPageDetails = {
  SeoName: { seotitle:"search-engine-optimization" },
  coverimage: DigitalMarketingCoverImage,
  title:"SEO Services in Vizag",
  categoryLabel:"Search Marketing",
  hero: {
    title:"Grow Your Business with Professional Search Engine Optimization Services in Vizag",
    subtitle:"Leor Media provides result-driven search engine optimization services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best search engine optimization services in Vizag?",
    text:"Leor Media is a trusted search engine optimization company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic search engine optimization solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Top Rankings", description:"Advanced SEO strategies for better Google visibility.", icon: faSearch },
    { title:"Lead Generation", description:"Attracting targeted customers through search optimization.", icon: faChartLine },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best search engine optimization company in Vizag?", answer:"Leor Media provides professional search engine optimization services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does search engine optimization cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized search engine optimization solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can search engine optimization help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 7. AFFILIATE MARKETING
export const AffiliateMarketingPageDetails = {
  SeoName: { seotitle:"affiliate-marketing" },
  coverimage: DigitalMarketingCoverImage,
  title:"Affiliate Marketing in Vizag",
  categoryLabel:"Performance Marketing",
  hero: {
    title:"Grow Your Business with Professional Affiliate Marketing Services in Vizag",
    subtitle:"Leor Media provides result-driven affiliate marketing services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best affiliate marketing services in Vizag?",
    text:"Leor Media is a trusted affiliate marketing company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic affiliate marketing solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Partner Network", description:"Leveraging networks for performance based growth.", icon: faSitemap },
    { title:"ROI Driven", description:"Marketing strategies designed for performance and scale.", icon: faChartLine },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best affiliate marketing company in Vizag?", answer:"Leor Media provides professional affiliate marketing services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does affiliate marketing cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized affiliate marketing solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can affiliate marketing help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 8. INFLUENCE MARKETING
export const InfluenceMarketingPageData = {
  SeoName: { seotitle:"influence-marketing" },
  coverimage: DigitalMarketingCoverImage,
  title:"Influence Marketing in Vizag",
  categoryLabel:"Influencer Services",
  hero: {
    title:"Grow Your Business with Professional Influence Marketing Services in Vizag",
    subtitle:"Leor Media provides result-driven influence marketing services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best influence marketing services in Vizag?",
    text:"Leor Media is a trusted influence marketing company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic influence marketing solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Authentic Reach", description:"Connecting brands with the right influencers for engagement.", icon: faUserFriends },
    { title:"Market Impact", description:"Performance driven strategies based on audience behavior.", icon: faChartLine },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best influence marketing company in Vizag?", answer:"Leor Media provides professional influence marketing services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does influence marketing cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized influence marketing solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can influence marketing help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 9. PPC
export const PpcPageData = {
  SeoName: { seotitle:"ppc" },
  coverimage: DigitalMarketingCoverImage,
  title:"PPC Services in Vizag",
  categoryLabel:"Paid Search",
  hero: {
    title:"Grow Your Business with Professional Ppc Services in Vizag",
    subtitle:"Leor Media provides result-driven ppc services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best ppc services in Vizag?",
    text:"Leor Media is a trusted ppc company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic ppc solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Instant Leads", description:"Targeted PPC campaigns based on audience behavior.", icon: faMousePointer },
    { title:"ROI Maximization", description:"ROI focused strategies for measurable business growth.", icon: faChartLine },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best ppc company in Vizag?", answer:"Leor Media provides professional ppc services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does ppc cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized ppc solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can ppc help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 10. CONTENT MARKETING
export const ContentMarketingPageDetails = {
  SeoName: { seotitle:"content-marketing" },
  coverimage: DigitalMarketingCoverImage,
  title:"Content Marketing in Vizag",
  categoryLabel:"Content Services",
  hero: {
    title:"Grow Your Business with Professional Content Marketing Services in Vizag",
    subtitle:"Leor Media provides result-driven content marketing services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best content marketing services in Vizag?",
    text:"Leor Media is a trusted content marketing company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic content marketing solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Storytelling", description:"Creative content solutions based on target audience trends.", icon: faFileLines },
    { title:"Brand Authority", description:"Building a powerful digital presence through content.", icon: faAward },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best content marketing company in Vizag?", answer:"Leor Media provides professional content marketing services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does content marketing cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized content marketing solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can content marketing help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 11. SOCIAL MEDIA MANAGEMENT
export const SocialMediaManagementPageDetails = {
  SeoName: { seotitle:"social-media-management" },
  coverimage: DigitalMarketingCoverImage,
  title:"Social Media Management in Vizag",
  categoryLabel:"Management Services",
  hero: {
    title:"Grow Your Business with Professional Social Media Management Services in Vizag",
    subtitle:"Leor Media provides result-driven social media management services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best social media management services in Vizag?",
    text:"Leor Media is a trusted social media management company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic social media management solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Daily Engagement", description:"Improving customer engagement through consistent social presence.", icon: faUsers },
    { title:"Brand Consistency", description:"Helping businesses build a powerful digital presence.", icon: faCheckCircle },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best social media management company in Vizag?", answer:"Leor Media provides professional social media management services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does social media management cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized social media management solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can social media management help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 12. DIGITAL CREATIVE MEDIA
export const DigitalCreativeMediaPageData = {
  SeoName: { seotitle:"digital-creative-media" },
  coverimage: DigitalMarketingCoverImage,
  title:"Digital Creative Media in Vizag",
  categoryLabel:"Creative Services",
  hero: {
    title:"Grow Your Business with Professional Digital Creative Media Services in Vizag",
    subtitle:"Leor Media provides result-driven digital creative media services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best digital creative media services in Vizag?",
    text:"Leor Media is a trusted digital creative media company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic digital creative media solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Visual Storytelling", description:"Creative solutions based on target audience behavior.", icon: faPalette },
    { title:"Market Impact", description:"Delivering measurable business growth through design.", icon: faChartLine },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best digital creative media company in Vizag?", answer:"Leor Media provides professional digital creative media services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does digital creative media cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized digital creative media solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can digital creative media help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 13. TVC/AD FILM MAKING
export const TvcAdFilmMakingPageData = {
  SeoName: { seotitle:"tvc-ad-film-making" },
  coverimage: DigitalMarketingCoverImage,
  title:"TVC/AD Film Making in Vizag",
  categoryLabel:"Film Production",
  hero: {
    title:"Grow Your Business with Professional Tvc/Ad Film Making Services in Vizag",
    subtitle:"Leor Media provides result-driven tvc/ad film making services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best tvc/ad film making services in Vizag?",
    text:"Leor Media is a trusted tvc/ad film making company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic tvc/ad film making solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Cinematic Quality", description:"Creative production based on industry trends.", icon: faFilm },
    { title:"Brand Vision", description:"Helping brands across Andhra Pradesh build a presence.", icon: faAward },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best tvc/ad film making company in Vizag?", answer:"Leor Media provides professional tvc/ad film making services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does tvc/ad film making cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized tvc/ad film making solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can tvc/ad film making help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 14. DIGITAL COMMERCIALS
export const DigitalCommercialsPageData = {
  SeoName: { seotitle:"digital-commercials" },
  coverimage: DigitalMarketingCoverImage,
  title:"Digital Commercials in Vizag",
  categoryLabel:"Commercial Production",
  hero: {
    title:"Grow Your Business with Professional Digital Commercials Services in Vizag",
    subtitle:"Leor Media provides result-driven digital commercials services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best digital commercials services in Vizag?",
    text:"Leor Media is a trusted digital commercials company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic digital commercials solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Catchy Content", description:"Creative commercial solutions based on audience trends.", icon: faVideo },
    { title:"Performance Ads", description:"Marketing strategies designed for digital scale.", icon: faChartLine },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best digital commercials company in Vizag?", answer:"Leor Media provides professional digital commercials services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does digital commercials cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized digital commercials solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can digital commercials help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 15. WEB COMMERCIALS
export const WebCommercialsPageData = {
  SeoName: { seotitle:"web-commercials" },
  coverimage: DigitalMarketingCoverImage,
  title:"Web Commercials in Vizag",
  categoryLabel:"Web Media",
  hero: {
    title:"Grow Your Business with Professional Web Commercials Services in Vizag",
    subtitle:"Leor Media provides result-driven web commercials services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best web commercials services in Vizag?",
    text:"Leor Media is a trusted web commercials company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic web commercials solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Web Focused", description:"Creative web solutions based on target audience trends.", icon: faGlobe },
    { title:"High Conversion", description:"Performance driven strategies for business growth.", icon: faChartLine },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best web commercials company in Vizag?", answer:"Leor Media provides professional web commercials services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does web commercials cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized web commercials solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can web commercials help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 16. PRODUCT & SERVICES EXPLANATORY VIDEOS
export const ProductServicesExplanatoryVideosPageData = {
  SeoName: { seotitle:"product-services-explanatory-videos" },
  coverimage: DigitalMarketingCoverImage,
  title:"Explanatory Videos in Vizag",
  categoryLabel:"Explanatory Media",
  hero: {
    title:"Grow Your Business with Professional Product & Services Explanatory Videos Services in Vizag",
    subtitle:"Leor Media provides result-driven product & services explanatory videos services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best product & services explanatory videos services in Vizag?",
    text:"Leor Media is a trusted product & services explanatory videos company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic product & services explanatory videos solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Clear Messaging", description:"Creative explanatory solutions based on audience behavior.", icon: faFileSignature },
    { title:"Conversion Oriented", description:"Delivering measurable growth through clear communication.", icon: faChartLine },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best product & services explanatory videos company in Vizag?", answer:"Leor Media provides professional product & services explanatory videos services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does product & services explanatory videos cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized product & services explanatory videos solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can product & services explanatory videos help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 17. COMPANY PROFILE VIDEOS
export const CompanyProfileVideosPageData = {
  SeoName: { seotitle:"company-profile-videos" },
  coverimage: DigitalMarketingCoverImage,
  title:"Company Profile Videos in Vizag",
  categoryLabel:"Corporate Media",
  hero: {
    title:"Grow Your Business with Professional Company Profile Videos Services in Vizag",
    subtitle:"Leor Media provides result-driven company profile videos services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best company profile videos services in Vizag?",
    text:"Leor Media is a trusted company profile videos company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic company profile videos solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Professional Legacy", description:"Helping businesses build a powerful digital presence.", icon: faIdCard },
    { title:"Stakeholder Trust", description:"Delivering measurable business growth through film.", icon: faCheckCircle },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best company profile videos company in Vizag?", answer:"Leor Media provides professional company profile videos services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does company profile videos cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized company profile videos solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can company profile videos help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 18. CUSTOMER TESTIMONIAL VIDEOS
export const CustomerTestimonialVideosPageData = {
  SeoName: { seotitle:"customer-testimonial-videos" },
  coverimage: DigitalMarketingCoverImage,
  title:"Testimonial Videos in Vizag",
  categoryLabel:"Testimonial Media",
  hero: {
    title:"Grow Your Business with Professional Customer Testimonial Videos Services in Vizag",
    subtitle:"Leor Media provides result-driven customer testimonial videos services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best customer testimonial videos services in Vizag?",
    text:"Leor Media is a trusted customer testimonial videos company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic customer testimonial videos solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Authentic Reviews", description:"Improving customer trust through video feedback.", icon: faCommentAlt },
    { title:"Social Proof", description:"Helping brands across Andhra Pradesh build trust.", icon: faAward },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best customer testimonial videos company in Vizag?", answer:"Leor Media provides professional customer testimonial videos services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does customer testimonial videos cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized customer testimonial videos solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can customer testimonial videos help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 19. COMPANY CORPORATE FILM
export const CompanyCorporateFilmPageData = {
  SeoName: { seotitle:"company-corporate-film" },
  coverimage: DigitalMarketingCoverImage,
  title:"Corporate Films in Vizag",
  categoryLabel:"Corporate Production",
  hero: {
    title:"Grow Your Business with Professional Company Corporate Film Services in Vizag",
    subtitle:"Leor Media provides result-driven company corporate film services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best company corporate film services in Vizag?",
    text:"Leor Media is a trusted company corporate film company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic company corporate film solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"High End Media", description:"Helping businesses build a powerful digital presence.", icon: faBuilding },
    { title:"Visionary Growth", description:"Delivering measurable business growth through corporate film.", icon: faChartLine },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best company corporate film company in Vizag?", answer:"Leor Media provides professional company corporate film services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does company corporate film cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized company corporate film solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can company corporate film help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 20. PRODUCT PHOTO & VIDEOGRAPHY
export const ProductPhotoVideographyPageData = {
  SeoName: { seotitle:"product-photo-videography" },
  coverimage: DigitalMarketingCoverImage,
  title:"Product Visuals in Vizag",
  categoryLabel:"Visual Services",
  hero: {
    title:"Grow Your Business with Professional Product Photo & Videography Services in Vizag",
    subtitle:"Leor Media provides result-driven product photo & videography services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best product photo & videography services in Vizag?",
    text:"Leor Media is a trusted product photo & videography company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic product photo & videography solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Crystal Clarity", description:"Creative visual solutions based on audience trends.", icon: faCamera },
    { title:"Sales Boost", description:"Marketing strategies designed for e-commerce growth.", icon: faChartLine },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best product photo & videography company in Vizag?", answer:"Leor Media provides professional product photo & videography services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does product photo & videography cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized product photo & videography solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can product photo & videography help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 21. MULTI-CHANNEL NETWORKING
export const MultiChannelNetworkingPageData = {
  SeoName: { seotitle:"multi-channel-networking" },
  coverimage: DigitalMarketingCoverImage,
  title:"Multi-channel Networking in Vizag",
  categoryLabel:"Networking Services",
  hero: {
    title:"Grow Your Business with Professional Multi-channel Networking Services in Vizag",
    subtitle:"Leor Media provides result-driven multi-channel networking services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best multi-channel networking services in Vizag?",
    text:"Leor Media is a trusted multi-channel networking company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic multi-channel networking solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Unified Brand", description:"Helping businesses build a powerful digital presence.", icon: faSitemap },
    { title:"Omni Growth", description:"Delivering measurable business growth through integration.", icon: faChartLine },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best multi-channel networking company in Vizag?", answer:"Leor Media provides professional multi-channel networking services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does multi-channel networking cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized multi-channel networking solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can multi-channel networking help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// 22. YOUTUBE ENTERTAINMENT
export const YoutubeEntertainmentPageData = {
  SeoName: { seotitle:"youtube-entertainment" },
  coverimage: DigitalMarketingCoverImage,
  title:"Youtube Entertainment in Vizag",
  categoryLabel:"YouTube Services",
  hero: {
    title:"Grow Your Business with Professional Youtube Entertainment Services in Vizag",
    subtitle:"Leor Media provides result-driven youtube entertainment services in Visakhapatnam for startups, local businesses, brands, and corporate businesses.",
    ctas: [
      { text:"Get Free Consultation", link:"/contactus", primary: true },
      { text:"Call Now", link:"tel:+919666643456", primary: false }
    ]
  },
  introduction: {
    heading:"Looking for the best youtube entertainment services in Vizag?",
    text:"Leor Media is a trusted youtube entertainment company in Visakhapatnam helping businesses increase brand visibility, generate quality leads, improve customer engagement, and grow faster online.",
    details:"With 10+ years of experience in branding, advertising, content creation, social media marketing, and digital promotions, we help businesses across Andhra Pradesh build a powerful digital presence."
  },
  whyChooseTitle:"Why Choose Leor Media",
  whyChooseDesc:"Businesses in Vizag need strategic youtube entertainment solutions to stay ahead of competitors. At Leor Media, we combine creativity, technology, and performance marketing strategies to deliver measurable business growth.",
  whyChoose: [
    { title:"Viral Content", description:"Creative production based on target audience trends.", icon: faTv },
    { title:"Channel Growth", description:"Marketing strategies designed for audience scale.", icon: faChartLine },
  ],
  trustTitle:"Trust & Proof",
  trustProof: [
    { value:"500+", label:"Campaigns Managed" },
    { value:"100+", label:"Happy Clients" },
    { value:"10+", label:"Years Experience" },
  ],
  faqs: [
    { question:"Which is the best youtube entertainment company in Vizag?", answer:"Leor Media provides professional youtube entertainment services in Visakhapatnam with customized strategies for local businesses and brands." },
    { question:"How much does youtube entertainment cost in Vizag?", answer:"The pricing depends on business goals, campaign requirements, and project scope. Leor Media offers customized packages for startups and established businesses." },
    { question:"Do you provide customized youtube entertainment solutions?", answer:"Yes, we create tailored strategies based on your business type, audience, and marketing objectives." },
    { question:"Can youtube entertainment help generate local business leads?", answer:"Yes, our strategies help businesses attract targeted customers through Google, social media platforms, and digital advertising." },
  ]
};

// FALLBACKS (If needed by routes)
export const SearchEngineOptimizationPageDetails_Backup = SearchEngineOptimizationPageDetails;
export const ContentMarketingPageDetails_Backup = ContentMarketingPageDetails;
export const SocialMediaMarketingPageDetails = SocialMediaManagementPageDetails;
export const PayPerClickAdvertisingPageDetails = PpcPageData;
export const AffiliateMarketingPageDetails_Backup = AffiliateMarketingPageDetails;
export const GenericDigitalMediaMarketingDetailPageData = DigitalMarketingPageData;
export const DigitalMediaMarketingDetailPageData = {"digital-marketing": DigitalMarketingPageData,"digital-strategy-consulting": DigitalStrategyConsultingPageData,"digital-media-buying": DigitalMediaBuyingPageData,"online-pr": OnlinePrPageData,"social-media-digital-campaign": SocialMediaDigitalCampaignPageData,"search-engine-optimization": SearchEngineOptimizationPageDetails,"affiliate-marketing": AffiliateMarketingPageDetails,"influence-marketing": InfluenceMarketingPageData,"ppc": PpcPageData,"content-marketing": ContentMarketingPageDetails,"social-media-management": SocialMediaManagementPageDetails,"digital-creative-media": DigitalCreativeMediaPageData,"tvc-ad-film-making": TvcAdFilmMakingPageData,"digital-commercials": DigitalCommercialsPageData,"web-commercials": WebCommercialsPageData,"product-services-explanatory-videos": ProductServicesExplanatoryVideosPageData,"company-profile-videos": CompanyProfileVideosPageData,"customer-testimonial-videos": CustomerTestimonialVideosPageData,"company-corporate-film": CompanyCorporateFilmPageData,"product-photo-videography": ProductPhotoVideographyPageData,"multi-channel-networking": MultiChannelNetworkingPageData,"youtube-entertainment": YoutubeEntertainmentPageData,
};

// Assign unique cover images to each subpage data object
DigitalMarketingCompany.coverimage = DigitalMarketingImg;
DigitalMarketingPageData.coverimage = DigitalMarketingImg;
DigitalStrategyConsultingPageData.coverimage = DigitalStrategyImg;
DigitalMediaBuyingPageData.coverimage = MediaBuyingImg;
OnlinePrPageData.coverimage = OnlinePrImg;
SocialMediaDigitalCampaignPageData.coverimage = SocialCampaignImg;
SearchEngineOptimizationPageDetails.coverimage = SEOImg;
AffiliateMarketingPageDetails.coverimage = AffiliateImg;
InfluenceMarketingPageData.coverimage = InfluenceImg;
PpcPageData.coverimage = PPCImg;
ContentMarketingPageDetails.coverimage = ContentMarketingImg;
SocialMediaManagementPageDetails.coverimage = SocialManagementImg;
DigitalCreativeMediaPageData.coverimage = CreativeMediaImg;
TvcAdFilmMakingPageData.coverimage = TvcMakingImg;
DigitalCommercialsPageData.coverimage = DigitalCommercialsImg;
WebCommercialsPageData.coverimage = WebCommercialsImg;
ProductServicesExplanatoryVideosPageData.coverimage = ExplanatoryVideosImg;
CompanyProfileVideosPageData.coverimage = CompanyProfileImg;
CustomerTestimonialVideosPageData.coverimage = CompanyProfileImg;
CompanyCorporateFilmPageData.coverimage = TvcMakingImg;
ProductPhotoVideographyPageData.coverimage = TvcMakingImg;
MultiChannelNetworkingPageData.coverimage = SocialManagementImg;
YoutubeEntertainmentPageData.coverimage = TvcMakingImg;

export const InfluencerMarketingPageDetails = InfluenceMarketingPageData;

